import { PlaybookStatus } from '@driftt/api-types'
import { Box, StatusBadge, Text, Tooltip } from '@driftt/dds'
import { pluralize } from 'humanize-plus'
import React from 'react'

import styles from './styles.module.css'

export function PlaybookUpdatesRequiredInCell({ playbookBlockData }) {
  const { updatesRequiredCount, onCount, offCount } = playbookBlockData.reduce(
    (summary, { isOutdated, playbookStatus }) => {
      if (!isOutdated) {
        return summary
      }

      summary.updatesRequiredCount++

      if (playbookStatus === PlaybookStatus.ENABLED) {
        summary.onCount++
      } else {
        summary.offCount++
      }

      return summary
    },
    { updatesRequiredCount: 0, onCount: 0, offCount: 0 }
  )

  if (!updatesRequiredCount) {
    return <Text>{'-'}</Text>
  }

  return (
    <Box className={styles.updatesRequiredCell}>
      <Tooltip
        flow="up"
        content={
          <Box className={styles.tooltipOnOffContainer}>
            {onCount > 0 && (
              <Box className={styles.tooltipStatusRow}>
                <StatusBadge variant="success" />
                <Text>{`${onCount} ${pluralize(onCount, 'playbook')}`}</Text>
              </Box>
            )}
            {offCount > 0 && (
              <Box className={styles.tooltipStatusRow}>
                <StatusBadge variant="error" />
                <Text>{`${offCount} ${pluralize(offCount, 'playbook')}`}</Text>
              </Box>
            )}
          </Box>
        }
      >
        <Box className={styles.playbooksCount}>
          {`${updatesRequiredCount} ${pluralize(
            updatesRequiredCount,
            'playbook'
          )}`}
        </Box>
      </Tooltip>
    </Box>
  )
}
